// extracted by mini-css-extract-plugin
export var button = "_dk-0";
export var donut = "_dk-1";
export var donutFill = "_dk-3";
export var donutTrack = "_dk-2";